import React from "react";
import MapboxGLMerdeMap from "./MapboxGLMerdeMap";
import ClusterSystemsCard from "./mySystemsForm.clusterSystemsCard";
import SystemLoggCard from "./mySystemsForm.systemsLoggCard";
import "./componentGrid.css";

export default function MySystemsForm({ myContent, myClusters, myLogg, userIsModerator, onUpdateLoggActive, onLoggUpdated }) {
  const activeLogg = myLogg?.filter((l) => l.active) ?? [];
  const historyLogg = myLogg
      ?.filter((l) => !l.active)
      .sort(
        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
      ) ?? [];


  return (
    <>
      <div className="viewcard22">
        <MapboxGLMerdeMap myContent={myContent} />
      </div>

      {myClusters?.map((cluster) => (
        <ClusterSystemsCard
          key={cluster.id ?? cluster.nick}
          cluster={cluster}
        />
      ))}

      <SystemLoggCard 
        title="Hendelseslogg"
        rows={activeLogg} 
        userIsModerator={userIsModerator}
        onUpdateLoggActive={onUpdateLoggActive}
        onLoggUpdated={onLoggUpdated}
      />

      <SystemLoggCard 
        title="Historikk"
        rows={historyLogg} 
        userIsModerator={userIsModerator}
        onUpdateLoggActive={onUpdateLoggActive}
        onLoggUpdated={onLoggUpdated} 
      />
    </>
  );
}
